module.exports = __webpack_public_path__ + "img/ad-footer.21252492.jpg";